import { Component, OnInit, Input, OnChanges, SimpleChanges, EventEmitter, Output, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, AbstractControl } from '@angular/forms';

@Component({
  selector: 'otp-code-input',
  templateUrl: './otp-code-input.component.html',
  styleUrls: ['./otp-code-input.component.scss'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => OtpCodeInputComponent),
    multi: true,
  }]
})
export class OtpCodeInputComponent implements OnInit, OnChanges, ControlValueAccessor {

  @Input() placeholder: string;
  @Input() step: string;
  @Input() min: number;
  @Input() max: number;
  @Input() label: string;
  @Input() name: string;
  @Input() type: string;
  @Input() errorMessage: string;
  @Input() errorMessageNoTranslate: string;
  @Input() maxlength: string;
  @Input() minlength: string;
  @Input() isUpperCase = false;
  @Input() eventClass: string = 'input-field';
  @Input() pattern: string;
  @Input() reverseErrorColor: boolean;
  @Output() change: EventEmitter<any> = new EventEmitter<any>();
  @Output() blur: EventEmitter<any> = new EventEmitter<any>();

  public idInput: string;
  public value: string = '';
  private propagateChange = (_: any) => { };
  private propagateTouch = () => { };

  constructor() { }

  ngOnInit() {
    this.idInput = `input-${this.name}`;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.name) {
      this.idInput = `input-${changes.name.currentValue}`;
    }
  }

  onChange(event) {
    // TODO: Temporary solution
    if (this.isUpperCase) {
      event.target.value = typeof event.target.value === 'string'
        ? event.target.value.toUpperCase()
        : event.target.value;
    }
    this.value = event.target.value;
    this.propagateChange(event.target.value);
    this.change.emit(event);
  }

  onBlur(event) {
    this.propagateTouch();
    this.blur.emit(event);
  }

  public writeValue(obj: any) {
    if (obj) {
      this.value = obj;
    }
  }

  public registerOnChange(fn: any) {
    this.propagateChange = fn;
  }

  public registerOnTouched(fn: any): void {
    this.propagateTouch = fn;
  }

}



// WEBPACK FOOTER //
// ./src/app/components/atoms/otp-code-input/otp-code-input.component.ts